export const Environment = {
    project: process.env.REACT_APP_SUBPROJECT ?? process.env.REACT_APP_PROJECT,
    isProd: process.env.REACT_APP_ENV === "production",
    isDev: process.env.REACT_APP_ENV === "development",
    isTest: process.env.REACT_APP_ENV === "staging",
};
